export default {"src":"/_next/static/media/deck.bfc439a1.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};